import { useNavigate } from 'react-router-dom';
import { HiXCircle, HiArrowLeft, HiRefresh } from 'react-icons/hi';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-6">

      {/* Header */}
      <div className="flex items-center gap-2 mb-10">
        <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center">
          <span className="text-white font-bold text-sm">P</span>
        </div>
        <span className="font-bold text-gray-900 text-lg tracking-tight">PortalFlow</span>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-10 max-w-md w-full text-center">

        {/* Icon */}
        <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <HiXCircle className="w-12 h-12 text-red-400" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Cancelled</h1>
        <p className="text-sm text-gray-500 mb-8 leading-relaxed">
          Your payment was not completed. No charges have been made.
          You can try again whenever you're ready.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="w-full flex items-center justify-center gap-2 bg-indigo-600
              hover:bg-indigo-700 text-white font-semibold py-3 rounded-xl transition text-sm"
          >
            <HiRefresh className="w-4 h-4" /> Try Again
          </button>
          <button
            onClick={() => navigate('/invoices')}
            className="w-full flex items-center justify-center gap-2 text-sm text-gray-500
              hover:text-gray-700 font-medium py-2 transition"
          >
            <HiArrowLeft className="w-4 h-4" /> Back to Invoices
          </button>
        </div>
      </div>

      <p className="text-xs text-gray-400 mt-8">
        Powered by <span className="font-semibold text-indigo-600">PortalFlow</span> · Secured by Stripe
      </p>
    </div>
  );
}
